import { Directive, ElementRef, Renderer2, Input } from '@angular/core';

@Directive({
  selector: '[ssLoading]',
  standalone: false
})
export class LoadingContentDirective {

  constructor(
    private el: ElementRef,
    private render: Renderer2
  ) { }

  @Input() set ssLoading(condition: boolean) {
    this.render.setAttribute(this.el.nativeElement, 'aria-busy', String(!!condition));
    if (condition) {
      this.render.removeClass(this.el.nativeElement, 'ss-loading-done');
      this.render.addClass(this.el.nativeElement, 'ss-loading');
    } else {
      this.render.removeClass(this.el.nativeElement, 'ss-loading');
      this.render.addClass(this.el.nativeElement, 'ss-loading-done');
    }
  }
}
